import React from 'react';
import {View} from 'react-native';
import {createStyles} from '../utils/createStyles';

export function WebLayoutWithBack(props: any) {
  return <View style={styles.container}>{props.children}</View>;
}

export function WebLayout(props: any) {
  return <View style={styles.containerAll}>{props.children}</View>;
}

const styles = createStyles({
  container: {
    height: 94 + 'vh',
    overflow: 'auto',
  },
  containerAll: {
    height: 100 + 'vh',
    overflow: 'auto',
  },
});
